const routes = {
  error: '/error',
  logout: '/logout',
  student: {
    main: {
      home: '/inicio',
      academicInformation: '/inicio/informacion-academica',
      institutionalInformation: '/inicio/informacion-institucional',
      registrationShift: '/inicio/horariosmatricula-turno',
      courseCatalog: '/inicio/catalogo-cursos',
      examRol: '/inicio/examen-rol',
      enrollmentSurvey: '/inicio/encuesta-matricula'
    },
    procedures: {
      home: '/tramites',
      created: '/tramites/estudiante/historico',
      createdEmbedded: '/tramites/estudiante/historicoportal',
      listScholarshipsDiscounts: '/tramites/becas-descuentos',
      list: '/tramites/:categoryName',
      charge: '/carga-monto-tramite',
      categories: {
        requests: {
          reincorporation: {
            info: '/tramites/autogestionables/solicitud/reincorporacion',
            register:
              '/tramites/autogestionables/solicitud/reincorporacion/registrar',
            progress:
              '/tramites/autogestionables/solicitud/reincorporacion/progreso'
          },
          issuancefuniversitycard: {
            procedureinfo:
              '/tramites/autogestionables/solicitud/emision-carnet-universitario',
            procedureregister:
              '/tramites/autogestionables/solicitud/emision-carnet-universitario/registrar',
            procedureprogress:
              '/tramites/autogestionables/solicitud/emision-carnet-universitario/progreso'
          },
          updatephoto: {
            procedureinfo: '/tramites/autogestionables/registro-foto',
            procedureregister:
              '/tramites/autogestionables/registro-foto/registrar',
            procedureprogress:
              '/tramites/autogestionables/registro-foto/progreso'
          },
          retirementperiod: {
            procedureinfo:
              '/tramites/autogestionables/solicitud/retiro-periodo-lectivo',
            procedureregister:
              '/tramites/autogestionables/solicitud/retiro-periodo-lectivo/registrar',
            procedureprogress:
              '/tramites/autogestionables/solicitud/retiro-periodo-lectivo/progreso'
          },
          changecareercampusmodality: {
            procedureinfo:
              '/tramites/solicitudes/cambio-carrera-campus-modalidad',
            procedureregister:
              '/tramites/solicitudes/cambio-carrera-campus-modalidad/registrar',
            procedureprogress:
              '/tramites/solicitudes/cambio-carrera-campus-modalidad/progreso'
          },
          changeStudiesOption: {
            procedureinfo:
              '/tramites/autogestionables/solicitud/cambio-opcion-estudio',
            procedureregister:
              '/tramites/autogestionables/solicitud/cambio-opcion-estudio/registrar',
            procedureprogress:
              '/tramites/autogestionables/solicitud/cambio-opcion-estudio/progreso'
          },
          certificateOfStudies: {
            procedureinfo:
              '/tramites/autogestionables/solicitud/certificado-de-estudios',
            procedureprogress:
              '/tramites/autogestionables/solicitud/certificado-de-estudios/progreso',
            procedureregister:
              '/tramites/autogestionables/solicitud/certificado-de-estudios/registro'
          },
          lateExamen: {
            register: '/tramites/autogestionables/solicitud/rezagado/registrar',
            info: '/tramites/autogestionables/solicitud/examen-rezagado/',
            progress: '/tramites/autogestionables/solicitud/rezagado/progreso'
          },
          retreatCourse: {
            info: '/tramites/autogestionables/solicitud/retiro-curso/',
            register:
              '/tramites/autogestionables/solicitud/retiro-curso/registrar',
            progress:
              '/tramites/autogestionables/solicitud/retiro-curso/progreso'
          },
          pse: {
            info: '/tramites/autogestionables/solicitud/validacion-seguro',
            register:
              '/tramites/autogestionables/solicitud/validacion-seguro/registrar',
            progress:
              '/tramites/autogestionables/solicitud/validacion-seguro/progreso'
          },
          employabilityCharter: {
            info: '/tramites/autogestionables/solicitud/emision-carta-empleabilidad',
            register:
              '/tramites/autogestionables/solicitud/emision-carta-empleabilidad/registrar',
            progress:
              '/tramites/autogestionables/solicitud/emision-carta-empleabilidad/progreso'
          },
          rectificationOfNotes: {
            info: '/tramites/autogestionables/solicitud/rectificacion-de-notas',
            register:
              '/tramites/autogestionables/solicitud/rectificacion-de-notas/registrar',
            progress:
              '/tramites/autogestionables/solicitud/rectificacion-de-notas/progreso'
          },
          GraduatedCertificate: {
            info: '/tramites/autogestionables/solicitud/certificado-de-egresado',
            register:
              '/tramites/autogestionables/solicitud/certificado-de-egresado/registrar',
            progress:
              '/tramites/autogestionables/solicitud/certificado-de-egresado/progreso'
          },
          // requestTemp: '/tramites/autogestionables/portal-estudiante/:requestName',
          // validationInsurance: '/tramites/solicitudes/validacion-seguro',
          // validationCardVaccination:
          //   '/tramites/solicitudes/validacion-carnet-vacunacion',
          fullCycleDiscount:
            '/tramites/autogestionables/descuento-ciclo-completo'
          // rectificationNotes: '/tramites/solicitudes/rectificacion-notas',
          // retreatCourse: '/tramites/solicitudes/retiro-curso',
          // examStragglers: '/tramites/solicitudes/examen-rezagados'
        },
        certificates: {
          certificatetype01: {
            // se cambio constancias por autogestionables
            procedureinfo: '/tramites/autogestionables/:certificatetype01name',
            procedureregister:
              '/tramites/autogestionables/:certificatetype01name/registro',
            procedureprogress:
              '/tramites/autogestionables/:certificatetype01name/progreso'
          },
          certificatetype02: {}
        },
        tickets: {
          register: '/tramites/ticketera/registro'
        },
        scholarships: {
          bse: {
            home: '/tramites/becas-descuentos/bse',
            register: '/tramites/becas-descuentos/bse/registro',
            progress: '/tramites/becas-descuentos/bse/progreso',
            procedureRegisterForms:
              '/tramites/becas-descuentos/bse/progreso/datos',
            supportingDocuments:
              '/tramites/becas-descuentos/bse/progreso/documentos'
          },
          agreements: {
            info: '/tramites/becas-descuentos/:type',
            register: '/tramites/becas-descuentos/:type/registro',
            progress: '/tramites/becas-descuentos/:type/progreso'
          }
        }
      }
    },
    schedule: {
      home: '/calendario'
    },
    events: {
      home: '/servicios/eventos/:category',
      detail: '/servicios/eventos/:category/detalle/:eventId'
    },
    reinforcements: {
      home: '/servicios/refuerzo-academico',
      detail: '/servicios/refuerzo-academico/:idReinforcement',
      embedded: '/servicios/ref-academico'
    },
    bse: {
      home: '/bse'
      // detail: '/bse/ingresos'
    },
    reservation: {
      tablets: {
        register: '/reserva/tablet/registro'
      },
      computers: {
        register: '/reserva/computadora/registro'
      },
      rooms: {
        register: '/inicio'
        // register: '/reserva/sala/registro'
      }
    },
    courses: {
      home: '/cursos',
      myCourses: '/cursos/mis-cursos',
      notesRecord: '/cursos/record-de-notas',
      notesRecordNew: '/cursos/record-de-notas-apolo',
      advanceCurriculum: '/cursos/avance-plan-de-estudios-apolo',
      advanceCurriculumOld: '/cursos/avance-plan-de-estudios',
      advanceCurriculumDetalle: '/cursos/avance-plan-de-estudios/detalle',
      progressiveCertifications: '/cursos/certificaciones-progresivas'
      // detail: '/cursos/detalle'
    },
    payments: {
      home: '/pagos',
      historial: '/pagos/historial',
      detail: '/pagos/detalle',
      balance: '/pagos/estado-cuenta',
      options: '/pagos/opciones-pago',
      online: '/pagos/opciones-pago/online'
    },
    services: {
      home: '/servicios',
      detail: '/servicios/detalle'
    },
    means: {
      home: '/servicios/recursos',
      detail: '/servicios/recursos/reserva/detalle'
    }
  },
  help: {
    home: '/conoce',
    category: '/conoce/categoria',
    subcategory: '/conoce/subcategoria',
    articles: '/conoce/articulos',
    article: '/conoce/articulo'
  },
  admin: {
    home: '/administrador',
    logout: '/logout'
  },
  profile: {
    home: '/perfil',
    personalInformation: '/perfil/informacion-personal'
  }
};

export default routes;
